import "./footer.css";

const Footer = () => {
  return (
    <div className="footer-my">
      <span>

        <a href="https://github.com/Nataliasw" target="_blank"> <i className="fab fa-github"></i> Github/Nataliasw</a>
      </span>
    </div>
  )
}

export default Footer;